import { retryUntilReady } from "./pixelRetry";

declare global {
	interface Window {
		ttq?: any;
	}
}

/**
 * Track a TikTok Pixel event (standard or custom)
 */
export const trackTikTokEvent = (eventName: string, params?: Record<string, any>): void => {
	const pixelId = process.env.REACT_APP_TIKTOK_PIXEL_ID;

	if (!pixelId) {
		console.log(`TikTok Pixel event skipped: ${eventName} (missing ID)`);
		return;
	}

	const fire = () => {
		window.ttq.track(eventName, params);
		console.log(`📊 TikTok Pixel event: ${eventName}`, params);
	};

	if (typeof window.ttq?.track === "function") {
		fire();
	} else {
		retryUntilReady(
			() => typeof window.ttq?.track === "function",
			fire,
			() => console.warn(`⚠️ TikTok Pixel not initialized, dropped event: ${eventName}`)
		);
	}
};
